import styled from 'styled-components';
import { Delete } from '@styled-icons/material-outlined/Delete';

export const CustomerUserTableMessage = styled.div`
  background-color: ${({ theme }) => theme.colors.waterBlue};
  border-radius: 0.25rem;
  text-align: center;
  padding: 0.125rem 0.25rem;

  & > span {
    font-size: 0.75rem;
    color: ${({ theme }) => theme.colors.grayDark2};
  }
`;

export const RemoveUserButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: unset;

  color: ${({ theme }) => theme.colors.red2};

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.red2};
    opacity: 0.75;
  }
`;

export const RemoveUserIcon = styled(Delete)`
  width: 1.125rem;
  margin-right: 0.25rem;
  color: ${({ theme }) => theme.colors.red2};
`;

export const BannerContainer = styled.div`
  left: -17vw;
  position: relative;
  z-index: 9;
  .hefesto-banner {
    position: absolute;
    width: max-content;
    top: 0;
  }

  @media (max-width: 1800px) {
    left: -29vw;
  }

  @media (max-width: 1300px) {
    left: -39vw;
  }
`;
